import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";

/**
 * @title Recommendation Settings
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.Recommendation)
@ComponentConfigurationClass("recommendationSettings")
export class RecommendationConfiguration {

    /**
     * @title Show initial recommendations
     * @description If enabled, displays the product recommendations before the first answer is given
     */
    public showInitialRecommendation?: boolean;

    /**
     * @title Number of recommendation pages in the questionnaire section
     * @minimum 1
     * @maximum 50
     */
    public numberOfRecommendationPagesInQuestionnaireSection?: number;

    /**
     * @minimum 0
     * @maximum 50
     */
    public numberOfProductsPerQuestionnairePage?: number;

    /**
     * @title Number of recommendation pages in the results section
     * @minimum 1
     * @maximum 50
     */
    public numberOfRecommendationPagesInResultsSection?: number;

    /**
     * @minimum 0
     * @maximum 50
     */
    public numberOfProductsPerResultsPage?: number;

    /**
     * @minimum 1
     * @maximum 6
     */
    public numberOfProductsPerResultsRow?: number;

    /**
     * @format custom-hidden
     * @deprecated
     */
    public numberOfNavigationPages?: number;

    /**
     * @title Number of bundles on the results page
     * @format custom-hidden
     * @minimum 0
     * @maximum 50
     */
    public numberOfBundlesPerPage?: number;

    /**
     * @title Show only one bundle at a time
     * @description The other bundles will be paginated
     * @format custom-hidden
     */
    public showOnlyOneBundlePerPage?: boolean;
}
